import { Theme, ThemeSchemeQuery } from 'src/models/userInterfaceSettings';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheColorSchemesQueryCallBack extends Callback<ThemeSchemeQuery[]> {
	public constructor(private readonly setColorSchemes: (themes: Array<Theme>) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: ThemeSchemeQuery[]): void => {
		const themes: Array<Theme> = [];

		successResponse.forEach((theme) => {
			themes.push(JSON.parse(theme.scheme) as Theme);
		});

		this.setColorSchemes(themes);
	};
}
